import { render, staticRenderFns } from "./BInputGroupFormInput.vue?vue&type=template&id=1fa91968&"
import script from "./BInputGroupFormInput.vue?vue&type=script&lang=js&"
export * from "./BInputGroupFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa91968')) {
      api.createRecord('1fa91968', component.options)
    } else {
      api.reload('1fa91968', component.options)
    }
    module.hot.accept("./BInputGroupFormInput.vue?vue&type=template&id=1fa91968&", function () {
      api.rerender('1fa91968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/forms/BInputGroupFormInput.vue"
export default component.exports